import { PremiumRole } from '../domains/premium-role';

export class LoadPremiumRoles {
  static readonly type = '[PremiumRole] Load';
}

export class LoadPremiumRolesSuccess {
  static readonly type = '[PremiumRole] Load Success';
  constructor(public roles: PremiumRole[]) {}
}

export class LoadPremiumRolesFail {
  static readonly type = '[PremiumRole] Load Fail';
  constructor(public error: unknown) {}
}
